import { render, staticRenderFns } from "./tads.vue?vue&type=template&id=06b24c70&"
import script from "./tads.vue?vue&type=script&lang=js&"
export * from "./tads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports